import React from 'react';
import { Box, Paper, Button, Typography, Container } from '@mui/material';
import Layout from './components/Layout';
import { useAuth } from './auth/AuthContext';

const ProfileView = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      // Use Auth0 logout which handles everything properly
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <Layout title="Profile">
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              padding: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
              Profile
            </Typography>

            {user && (
              <Box sx={{ mb: 3, textAlign: 'center' }}>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Email: {user.email}
                </Typography>
                {user.name && (
                  <Typography variant="body1" sx={{ mb: 1 }}>
                    Name: {user.name}
                  </Typography>
                )}
              </Box>
            )}

            <Button
              variant="contained"
              color="error"
              onClick={handleLogout}
              sx={{ mt: 3 }}
            >
              Logout
            </Button>
          </Paper>
        </Box>
      </Container>
    </Layout>
  );
};

export default ProfileView;
